/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Intent, Popover, PopoverInteractionKind, Position, Tooltip } from "@blueprintjs/core"
import { MouseEvent, useEffect, useState } from "react"
import { DIALOG_SIZE, HasId, ID } from "src/libs/interfaces/layouts"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ScalableDialog } from "src/libs/useful"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { __ } from "src/libs/utilities"
import { ISyncState, useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { DataContentContent, ILandingContent, LANDING_TYPE_CONTENT } from "../../data/interfaces"
import FieldChanger from "../../views/landing/landing-edit/FieldChanger"
import MeatSelectorList from "../../views/landing/landing-edit/MeatSelectorList"
import createMeat from "../../views/landing/landing-edit/utils/createMeat"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"

/* Protopia Ecosystem component */
export interface IDataContentScalarProps  extends ICompositeWidgetProps{
    max?: number
}

export const MAX_INCUT_LENGTH: number = 20
export const DEFAULT_DATA_CONTENT: ILandingContent = {
    id: "",
    position: {},
    type: LANDING_TYPE_CONTENT.DATA_CONTENT,
    data: [{
        type: LANDING_TYPE_CONTENT.HTML,
        data: "Some text"
    }]
} as ILandingContent

const DataContentScalar = (props: IDataContentScalarProps): JSX.Element => {
    // console.log( props.subMenus )  
    return <> 
        <Scalar  
            value={ props.value }
            editable={props.editable }
            subtitle={props.title || props.subtitle}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <DataContentScalarEnabled {...props} /> }  
            desabledForm={ <DataContentScalarDisable {...props} /> }  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
        />
    </>
}
const DataContentScalarDisable = (props: IDataContentScalarProps): JSX.Element => {
    return <>- DataContentScalarDisable -</>
}
const DataContentScalarEnabled = (props: IDataContentScalarProps): JSX.Element => {

    const getData = ( value: ILandingContent | ILandingContent[] | undefined ) : ILandingContent => {  
        if( Array.isArray(value)) {
            return {
                id: "",
                position: {},
                type: LANDING_TYPE_CONTENT.DATA_CONTENT,
                data: !!value 
                    ?
                    value
                    :
                    DEFAULT_DATA_CONTENT
            } as ILandingContent
        }
        else if(value?.type === LANDING_TYPE_CONTENT.DATA_CONTENT) {
             return value
        }
        return DEFAULT_DATA_CONTENT
    }
    const value = useSyncState<DataContentContent | any>( getData( props.value || props.default ) )
    useEffect(() => {
        value.set( getData( props.value || props.default  ) )
    }, [props.value, props.default ])

    if( value.get().type !== LANDING_TYPE_CONTENT.DATA_CONTENT) {
        return <CalloutNoExists message={__( "Error data need DataContent. Exists:" ) + " " + value.get().type } />
    }
    const onSingleChange = (id: ID, _value: any, field: string, dop: any) => { 
        const newValue = {
            ...value.get(),
            data: value.get().data.map( (v: any) => {
                return _value
            }) 
        }
        value.set( newValue )
        onChange()
    }
    const onRmv = ( evt: MouseEvent<HTMLElement>, id: ID ) => {
        const newValue = {
            ...value.get(),
            data: value.get().data.filter( ( v: HasId ) => v.id !== id )
        }
        value.set( newValue )
        onChange()
        evt.preventDefault()
        evt.stopPropagation()
    }
    const onDbl = ( evt: MouseEvent<HTMLElement>, id: ID ) => { 
        evt.preventDefault()
        evt.stopPropagation()
    }
    const onAdd = ( evt: any, key: string, n: number = 0 ) => {
        const newValue = {
            ...value.get(),
            data: [
                ...value.get().data,
                createMeat(key, n, {}) 
            ]
        }
        value.set( newValue )
        onChange()
    }
    const onChange = () => { 
        if(props.onChange) {
            props.onChange(value.get(), props.field, "")
        }
    }
    
    const items: any[] =  value.get().data?.filter( ( item: any , i: number ) => i < Math.min( MAX_INCUT_LENGTH, ( props.max || MAX_INCUT_LENGTH ) ) )
    return  <div className="m-1 pl-2 pr-3 pt-3 pb-2 bg-contrast-secondary-opacity-- w-100"> 
        <div className="w-100 "> 
            <div>
                { 
                    items.map( ( item: ILandingContent, i: number ) => { 
                        return <div className="border1 border-contrast-secondary-opacity w-100 position-relative " key={ item.id }> 
                            <DataContentContentForm 
                                value={ value } 
                                v={ item } 
                                i={i} 
                                visualization={ props.visualization } 
                                onSingleChange={ onSingleChange } 
                                onDbl={ onDbl } 
                                onRmv={ onRmv }   
                            /> 
                        </div>
                    })
                } 
                {
                    !!props.max && 
                    value.get().data?.length < props.max &&
                        <Popover 
                            position={ Position.BOTTOM_LEFT }
                            interactionKind={ PopoverInteractionKind.CLICK }
                            content={ <MeatSelectorList onClick={onAdd} /> } 
                            portalClassName="z-index-130" 
                            className="w-100"
                        >
                            <Button variant={ ButtonVariant.MINIMAL } alignText="right" endIcon="plus" fill >
                                {__("Add")}
                            </Button>
                        </Popover> 
                }
            </div>
            {
                props.commentary &&
                <div className="py-3 small letter-spacing-1 opacity_75 text-italic" dangerouslySetInnerHTML={{__html:__(props.commentary)}} />
            } 
        </div>
    </div>
}
export default DataContentScalar

interface IDataContentContentFormProps {
    value: ISyncState<any>
    v: any
    i: number
    visualization?: string
    onSingleChange: (id: ID, _value: any, field: string, dop: any) => void
    onDbl: (evt: MouseEvent<HTMLElement, globalThis.MouseEvent>, id: ID) => void
    onRmv: (evt: MouseEvent<HTMLElement, globalThis.MouseEvent>, id: ID) => void
}
export const DataContentContentForm = ({value, v, i, visualization, onSingleChange, onDbl, onRmv }: IDataContentContentFormProps) : JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const onClose = () => {
        setIsOpen(false)
    }
    return <div className="border1 border-contrast-secondary-opacity w-100 position-relative " key={ v.id }> 
        <Button size="large" fill className="btn-stretch p-0" variant={ButtonVariant.MINIMAL} onClick={ () => setIsOpen(!isOpen) }>
            <div className="d-flex align-items-center w-100">
                <div className=" px-3 text-uppercase smaller letter-spacing-1 mr-auto">
                    { __( v.type ) } 
                </div>
                <div className="d-flex pe-surface">
                    {
                        value.get().data.length < MAX_INCUT_LENGTH &&
                            <Tooltip
                                intent={Intent.PRIMARY}
                                compact
                                position={Position.TOP_RIGHT}
                                content={<div className="small letter-spacing-2">{__("Double")}</div>}
                            >
                                <Button variant={ ButtonVariant.MINIMAL } icon="duplicate" onClick={(evt: MouseEvent<HTMLElement>) => onDbl( evt, v.id )} > 
                                </Button>
                            </Tooltip>
                    }
                    {
                        i < value.get().data.length - 1 &&
                            <Tooltip
                                intent={Intent.PRIMARY}
                                compact
                                position={Position.TOP_RIGHT}
                                content={<div className="small letter-spacing-2">{__("Switch down")}</div>}
                            >
                                <Button variant={ ButtonVariant.MINIMAL } icon="arrow-down" onClick={(evt: MouseEvent<HTMLElement>) => onDbl( evt, v.id )} > 
                                </Button>
                            </Tooltip>
                    }
                    {
                        i > 0 &&
                            
                            <Tooltip
                                intent={Intent.PRIMARY}
                                compact
                                position={Position.TOP_RIGHT}
                                content={<div className="small letter-spacing-2">{__("Switch up")}</div>}
                            >
                                <Button variant={ ButtonVariant.MINIMAL } icon="arrow-up" onClick={(evt: MouseEvent<HTMLElement>) => onDbl( evt, v.id )} > 
                                </Button>
                            </Tooltip>
                    }
                    
                    <Tooltip
                        intent={Intent.PRIMARY}
                        compact
                        position={Position.TOP_RIGHT}
                        content={<div className="small letter-spacing-2">{__("Delete")}</div>}
                    >
                        <Button intent={Intent.DANGER} variant={ ButtonVariant.MINIMAL } onClick={(evt: MouseEvent<HTMLElement>) => onRmv( evt, v.id )} >
                            <div className="flex-centered">
                                <Icon icon="trash"  /> 
                            </div>
                        </Button>
                    </Tooltip>
                </div> 
            </div>
        </Button>       
        <ScalableDialog
            isOpen={isOpen} 
            onClose={onClose}
            // title={__( v.type )}  
            dialogSize={ DIALOG_SIZE.NORMAL } 
        >
            <div className="p-4">
                <FieldChanger 
                    editable
                    type={v.type}
                    dataName={v.type}
                    visualization={ visualization }
                    dataSection={"Section"}
                    title={__( v.type )}
                    field={ parseField( v.type ) }
                    value={ parseValue( v.type, v ) }
                    origin={ v } // TODO:: не проверено!!!
                    onChange={ (value: any, field: string, dop: any) => onSingleChange (v.id, value, field, dop) }
                    noDefault
                    isNotCard
                    isDefaultOpen={ false }
                    notClear
                />    
            </div>
             
        </ScalableDialog> 
    </div>
}

const parseValue = (type: string, value: any): any => {
    switch(type) {
        case LANDING_TYPE_CONTENT.IMAGE:
            return value 
        case LANDING_TYPE_CONTENT.ICON:
            return value 
        case LANDING_TYPE_CONTENT.HTML:
        default:
            return value
    }
}
const parseField = (type: string ): any => {
    switch(type) {
        case LANDING_TYPE_CONTENT.IMAGE:
            return ""
        case LANDING_TYPE_CONTENT.ICON:
            return ""
        case LANDING_TYPE_CONTENT.HTML:
        default:
            return ""
    }
}
